// import { useMemo } from 'react';
// import { useLocation } from 'react-router-dom';

// const useApp = () => {
//   const location = useLocation();

//   const currentMenuNameFullScreen = useMemo(() => {
//     return location.pathname;
//   }, [location.pathname]);
//   return { currentMenuNameFullScreen };
// };

// export default useApp;

import { useEffect, useMemo } from "react";
import { useLocation, matchPath } from "react-router-dom";

const useApp = () => {
  const location = useLocation();

  const currentMenuNameFullScreen = useMemo(() => {
    const pathname = location.pathname;

    if (matchPath("/order/list/edit/:id", pathname)) {
      return "/order/list/edit/:id";
    }
    if (matchPath("/order/list/sentToManager/edit/:id", pathname)) {
      return "/order/list/sentToManager/edit/:id";
    }
    if (matchPath("/customer/:customerId/policy/:policyNumber", pathname)) {
      return "/customer/:customerId/policy/:policyNumber";
    }

    if (matchPath("/profile/customer/:id", pathname)) {
      return "/profile/customer/:id";
    }

    return pathname;
  }, [location.pathname]);

  useEffect(() => {
    const match = matchPath("/profile/customer/:id", location.pathname);
    if (match && match.params?.id) {
      localStorage.setItem("lastCustomerId", match.params.id);
    }
  }, [location.pathname]);

  return { currentMenuNameFullScreen };
};

export default useApp;

